/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { logoStyle } from "assets/jss/material-kit-pro-react/components/headerStyle";

const styles = (theme) => {
  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.secondary.main;
  const warningColor = theme.palette.warning.main;
  const warningClrDark = theme.palette.warning.dark;
  const testColor = theme.palette.test.main;

  const titleBar = {
    color: "white",
    padding: "0.25rem 1rem",
  };

  const actionBar = {
    ...titleBar,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const groupStyle = {
    border: "2px solid #E98D24",
    borderRadius: "6px",
    margin: "0.5rem 1rem",
    padding: "1rem",
    width: "90%",
  };

  const report = {
    fontWeight: 600,
    margin: "1rem 0",
    "& div": { marginLeft: "2rem" },
  };

  const moveable = {
    border: "1px solid #A0A0A0",
    borderRadius: "4px",
    padding: "0.25rem",
    backgroundColor: theme.palette.paper.light,
  };

  return {
    exContainer: {
      "@media (min-width: 960px)": {
        padding: "1rem 2rem",
      },
      padding: "1rem 2px",
      background: "#FFFFFF",
      "& div": { fontFamily: "Open Sans", fontSize: "1.2rem" },
    },

    titleBarEx: {
      ...titleBar,
      backgroundColor: testColor,
    },

    titleBarAsm: {
      ...titleBar,
      backgroundColor: warningClrDark,
    },

    logo: {
      ...logoStyle,
    },

    actionsEx: {
      ...actionBar,
      backgroundColor: testColor,
    },

    actionsAsm: {
      ...actionBar,
      backgroundColor: warningClrDark,
    },

    titleText: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    testGroup: {
      fontWeight: 700,
    },

    statement: {
      fontSize: "1.2rem",
      fontWeight: 400,
      lineHeight: "150%",
      marginBottom: "0.25rem",
      color: "#777",
    },

    itemPart: {
      margin: "0.5rem 0 0.5rem 1rem",
    },

    itemRight: {
      margin: "0.25rem",
      width: "100%",
      ...moveable,
    },

    itemCat: {
      margin: "0.75rem 0",
      ...moveable,
    },

    grabGreen: {
      margin: "auto 1rem auto 0",
      color: secondaryColor,
    },

    sourceGroup: {
      ...groupStyle,
      borderColor: primaryColor,
      width: "50%",
    },

    targetGroup: {
      ...groupStyle,
      borderColor: secondaryColor,
    },

    initWarn: {
      "& p": {
        fontSize: "1.2rem",
        color: "#606060",
        margin: "0.5rem",
        padding: "0.5rem 0",
        borderBottom: `1px solid ${testColor}`,
      },
      margin: "1rem 0.5rem",
    },

    mainReport: {
      ...report,
      fontFamily: "Open Sans",
      fontSize: "1.2rem",
      color: testColor,
    },

    reportLine: {
      display: "flex",
      alignItems: "flex-start",
      color: "#777",
      marginBottom: "0.25rem",
    },

    reportCorrect: {
      ...report,
      color: secondaryColor,
    },

    reportWrong: {
      ...report,
      color: warningColor,
    },

    reportFeedback: {
      ...report,
      color: primaryColor,
    },

    "@keyframes blinker": {
      "50%": {
        opacity: 0,
      },
    },

    showTime: {
      fontSize: "2rem",
      fontFamily: "Open Sans",
      marginBottom: 0,
      color: "white",
    },
    blink_me: { animation: "$blinker 1s linear infinite" },
    timeUp: { color: primaryColor },

    chkbox: {
      fontSize: "1.2rem",
      fontWeight: 600,
      color: "black",
    },
    chkbox2: {
      fontSize: "1.2rem",
      fontWeight: 600,
      color: theme.palette.warning.main,
    },
  };
};

export default styles;
